package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.FinancialSummaryDto
import com.evoapps.evoshift.domain.model.FinancialSummary
import com.evoapps.evoshift.domain.model.LabourBase

class FinancialSummaryMapper {

    fun toDomain(dto: FinancialSummaryDto): FinancialSummary {
        return FinancialSummary(
            laborCost = dto.laborCost,
            otherCosts = dto.otherCosts,
            revenue = dto.revenue,
            laborPercentage = dto.laborPercentage,
            commission = dto.commission,
            fixedRevenue = dto.fixedRevenue,
            otherRevenue = dto.otherRevenue,
            laborBase = dto.laborBase?.let { base -> LabourBase.entries.firstOrNull { it.name == base } },
            laborIncome = dto.laborIncome,
            salesIncome = dto.salesIncome
        )
    }

    fun toDto(domain: FinancialSummary): FinancialSummaryDto {
        return FinancialSummaryDto(
            laborCost = domain.laborCost,
            otherCosts = domain.otherCosts,
            revenue = domain.revenue,
            laborPercentage = domain.laborPercentage,
            commission = domain.commission,
            fixedRevenue = domain.fixedRevenue,
            otherRevenue = domain.otherRevenue,
            laborBase = domain.laborBase?.name,
            laborIncome = domain.laborIncome,
            laborPercentageOfIncome = domain.laborIncome?.let { domain.labourPercent },
            salesIncome = domain.salesIncome
        )
    }
}
